<section>
  <div class="wrapper container-fluid">
    <article class="mrt-75" style="overflow-y: auto !important;overflow-x: hidden !important; min-height: calc(100vh - 117px);">
      <div class="row">
        <div class="form-container">
          <mat-tab-group [(selectedIndex)]="selectedIndex"  (selectedIndexChange)="onTabChange($event)" class="tabs">
            <mat-tab label="Users">  
              <div class="header-container">
                <div class="title-container">
                  <h2 class="label">
                    <mat-icon class="users people-icon">people</mat-icon>
                    <span class="title">Users</span>
                  </h2>
                </div>
                <form [formGroup]="myForm" class="form-inline um-toolbar">

                  <mat-form-field *ngIf="showDropdown" appearance="fill" floatLabel="always" class="form-field filter-field">
                    <mat-label>Verified Users</mat-label>
                    <mat-select panelClass="um-select-panel" [(value)]="verified" (selectionChange)="onSelectionChange($event, 'verified')">
                      <mat-option value="">All</mat-option>
                      <mat-option value="true">True</mat-option>
                      <mat-option value="false">False</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
                    <mat-label>User</mat-label>
                    <mat-select panelClass="um-select-panel" [(value)]="user" (selectionChange)="onSelectionChange($event, 'user')">
                      <mat-option value="">All</mat-option>
                      <mat-option value="pv">PV</mat-option>
                      <mat-option value="Non pv">Non PV</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
                    <mat-label>Type</mat-label>
                    <mat-select panelClass="um-select-panel" [(value)]="userType" (selectionChange)="onSelectionChange($event, 'userType')">
                      <mat-option value="">All</mat-option>
                      <mat-option value="Administrator">Administrator</mat-option>
                      <mat-option value="Customer">Customer</mat-option>
                      <mat-option value="US Admin">US Admin</mat-option>
                      <mat-option value="Sales Rep">Sales Rep</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field">
                    <mat-label>Status</mat-label>
                    <mat-select panelClass="um-select-panel" [(value)]="status" (selectionChange)="onSelectionChange($event, 'status')">
                      <mat-option value="">All</mat-option>
                      <mat-option value="active">Active</mat-option>
                      <mat-option value="inactive">Inactive</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="fill" floatLabel="always" class="form-field search-field">
                    <mat-label>Search</mat-label>
                    <input matInput formControlName="searchKeyword">
                    <button mat-icon-button matSuffix class="suffix-icon-btn" (click)="fetchUserData()">
                      <mat-icon>search</mat-icon>
                    </button>
                    <button mat-icon-button matSuffix class="suffix-icon-btn search-clear-btn" [class.search-clear-btn--hidden]="!myForm.controls['searchKeyword'].value" (click)="clearSearch()">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>

                  <div class="toolbar-actions" *ngIf="showDropdown">
                    <button mat-icon-button (click)="downloadCSV()" matTooltip="Download CSV" aria-label="Download CSV" class="toolbar-icon-btn download-button">
                      <mat-icon>download</mat-icon>
                    </button>
                  </div>
                
                </form>
                <div class="button-group toolbar-actions" *ngIf="canEditUsers">
                  <button mat-icon-button class="toolbar-icon-btn save-btn" matTooltip="Add user" (click)="addUser()">
                    <mat-icon>add</mat-icon>
                  </button>
                  <button mat-icon-button class="toolbar-icon-btn save-btn config" matTooltip="Camera config" (click)="cameraConfig()">
                    <mat-icon>tune</mat-icon>
                  </button>
                </div>
              </div>
              <div class="table-container table-responsive um-table-wrap">
                <div>
                  <table mat-table [dataSource]="dataSource" matSort class="mat-table um-table um-table-users">
                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                      <th class="left-sorted-header col-name" mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                      <td class="left-sorted-header col-name" mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>
    
                    <!-- Username Column -->
                    <ng-container matColumnDef="username">
                      <th class="left-sorted-header col-username" mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
                      <td class="left-sorted-header col-username" mat-cell *matCellDef="let element">{{ element.userName }}</td>
                    </ng-container>
    
                    <!-- Email ID Column -->
                    <ng-container matColumnDef="emailid">
                      <th class="left-sorted-header col-email" mat-header-cell *matHeaderCellDef mat-sort-header>Email ID</th>
                      <td class="left-sorted-header col-email" mat-cell *matCellDef="let element">{{ element.emailId }}</td>
                    </ng-container>
    
                    <!-- Phone No Column -->
                    <ng-container matColumnDef="phone">
                      <th class="left-sorted-header col-phone" mat-header-cell *matHeaderCellDef mat-sort-header>Phone No.</th>
                      <td class="left-sorted-header col-phone" mat-cell *matCellDef="let element">{{ element.phoneNo }}</td>
                    </ng-container>
    
                    <!-- Sites Count Column -->
                    <ng-container matColumnDef="sites">
                      <th class="centered-sorted-header col-sites" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">Sites</th>
                      <td class="centered-sorted-header col-sites site-count-btn" mat-cell *matCellDef="let element; let i= index;" 
                          (click)="((element.userType == 'Customer' || element.userType == 'Sales Rep' || element.userType == 'CUSTOMER') && element.potentialList?.length) ? openSitesListDialog(element) : null">
                        <div class="count-badge">
                          {{(element.userType == 'Customer' || element.userType == 'Sales Rep' || element.userType == 'CUSTOMER') ? (element?.potentialList?.length || 0) : 'All' }}
                        </div>
                      </td>
                    </ng-container>

                    <!-- User Type Column -->
                    <ng-container matColumnDef="usertype">
                      <th class="left-sorted-header col-type" mat-header-cell *matHeaderCellDef mat-sort-header>User Type</th>
                      <td class="left-sorted-header col-type" mat-cell *matCellDef="let element">{{ element.userType }}</td>
                    </ng-container>
    
                    <!-- Last Login Column -->
                    <ng-container matColumnDef="lastLogin">
                      <th class="centered-sorted-header col-date" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">Last Login</th>
                      <td class="centered-sorted-header col-date" mat-cell *matCellDef="let element">{{ element?.lastLogin }}</td>
                    </ng-container>
    
    <ng-container  matColumnDef="action">
      <th class="right-sorted-header col-actions" mat-header-cell *matHeaderCellDef>Action</th>
      <td class="right-sorted-header col-actions" mat-cell *matCellDef="let element">
        <div class="table-action-group">
          <button mat-icon-button class="table-action-icon" (click)="restrictUser(element)" matTooltip="Restrict User" [disabled]="!element.active">
            <mat-icon>tune</mat-icon>
          </button>
          <button mat-icon-button class="table-action-icon" (click)="editUser(element)" matTooltip="Edit User" [disabled]="!element.active">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button class="table-action-icon" (click)="changePassword(element)" matTooltip="Change Password" [disabled]="!element.active">
            <mat-icon>lock_reset</mat-icon>
          </button>
          <button mat-icon-button class="table-action-icon" *ngIf="isSuperAdmin" (click)="openPreferences(element)" matTooltip="Preferences" [disabled]="!element.active">
            <mat-icon>settings</mat-icon>
          </button>
          <button
            mat-icon-button
            class="table-action-icon"
            *ngIf="!element.active"
            (click)="changeStatus(element)"
            matTooltip="Activate User"
            >
            <mat-icon>person_add</mat-icon>
          </button>
          <button
            mat-icon-button
            class="table-action-icon"
            *ngIf="element.active"
            (click)="deleteUser(element)"
            matTooltip="Deactivate User"
          >
            <mat-icon>person_remove</mat-icon>
          </button>      
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
       </table>
    </div>
  
  <!-- Pagination -->
  <mat-paginator [length]="totalElements" 
  [pageSize]="pageSize"
  [pageSizeOptions]="[8, 25, 50, 100]"
  [pageIndex]="pageIndex"
  showFirstLastButtons 
  (page)="onPageChange($event)"></mat-paginator>
</div>
            </mat-tab>
            <mat-tab label="Sites">
  <div class="header-container">
    <div class="title-container">
      <h2 class="label">
        <mat-icon name="list" class="list people-icon">list</mat-icon>
        <span class="title site-title">Sites</span>
      </h2>
    </div>
  <form [formGroup]="sitesForm" class="form-inline um-toolbar">

    <mat-form-field *ngIf="showDropdown" appearance="fill" floatLabel="always" class="form-field filter-field filter-field-wide">
      <mat-label>LOS</mat-label>
      <mat-select panelClass="um-select-panel" [(value)]="los" (selectionChange)="onSelectionSiteChange($event, 'los')">
        <mat-option value="">All</mat-option>
        <mat-option value="Silver">Silver</mat-option>
        <mat-option value="Enterprise">Enterprise</mat-option>
        <mat-option value="Platinum">Platinum</mat-option>
        <mat-option value="Fixed Bronze">Fixed Bronze</mat-option>
        <mat-option value="Gold">Gold</mat-option>
        <mat-option value="Mobile Bronze">Mobile Bronze</mat-option>
        <mat-option value="Mobile Silver">Mobile Silver</mat-option>
        <mat-option value="Mobile">Mobile</mat-option>
        <mat-option value="Customer Support">Customer Support</mat-option>
        <mat-option value="Bronze">Bronze</mat-option>
        <mat-option value="Fixed Silver">Fixed Silver</mat-option>
        <mat-option value="Fixed Gold">Fixed Gold</mat-option>
        <mat-option value="Platinum Mobile">Platinum Mobile</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="showDropdown" appearance="fill" floatLabel="always" class="form-field search-field">
      <mat-label>Cams</mat-label>
      <input matInput formControlName="cameraKey" type="text">
      <button mat-icon-button matSuffix class="suffix-icon-btn" (click)="loadSites(sitePageSize,sitePageIndex)">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button matSuffix class="suffix-icon-btn search-clear-btn" [class.search-clear-btn--hidden]="!sitesForm.controls['cameraKey'].value" (click)="clearSiteSearch()">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field *ngIf="showDropdown" appearance="fill" floatLabel="always" class="form-field search-field">
      <mat-label>City</mat-label>
      <input matInput formControlName="cityKey">
      <button mat-icon-button matSuffix class="suffix-icon-btn" (click)="loadSites(sitePageSize,sitePageIndex)">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button matSuffix class="suffix-icon-btn search-clear-btn" [class.search-clear-btn--hidden]="!sitesForm.controls['cityKey'].value" (click)="clearSiteSearch()">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field *ngIf="showDropdown" appearance="fill" floatLabel="always" class="form-field search-field">
      <mat-label>State</mat-label>
      <input matInput formControlName="stateKey">
      <button mat-icon-button matSuffix class="suffix-icon-btn" (click)="loadSites(sitePageSize,sitePageIndex)">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button matSuffix class="suffix-icon-btn search-clear-btn" [class.search-clear-btn--hidden]="!sitesForm.controls['stateKey'].value" (click)="clearSiteSearch()">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" class="form-field search-field search-field-main">
      <mat-label>Search</mat-label>
      <input matInput formControlName="searchKey">
      <button mat-icon-button matSuffix class="suffix-icon-btn" (click)="loadSites(sitePageSize,sitePageIndex)">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button matSuffix class="suffix-icon-btn search-clear-btn" [class.search-clear-btn--hidden]="!sitesForm.controls['searchKey'].value" (click)="clearSiteSearch()">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>
  </form>
</div>
  <div class="table-container table-responsive um-table-wrap">
    <div>
      <table mat-table [dataSource]="sitesDataSource" matSort class="mat-table um-table um-table-sites">
        <!-- Name Column -->
        <ng-container matColumnDef="siteName">
          <th class="left-sorted-header col-site-name" mat-header-cell *matHeaderCellDef mat-sort-header>Site Name</th>
          <td class="left-sorted-header col-site-name" mat-cell *matCellDef="let element">
            <ng-container *ngIf="isSuperAdmin; else regularSiteName">
              <a href="javascript:void(0)" (click)="openSiteReportModal(element.siteName)" class="site-link">
                {{ element.siteName }}
              </a>
            </ng-container>
            <ng-template #regularSiteName>
              {{ element.siteName }}
            </ng-template>
          </td>
        </ng-container>

        <!-- Username Column -->
        <ng-container matColumnDef="accountName">
          <th class="left-sorted-header col-account" mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
          <td class="left-sorted-header col-account" mat-cell *matCellDef="let element">{{ element.accountName }}</td>
        </ng-container>

        <!-- Cam Count Column -->
          <ng-container matColumnDef="numberOfCameras">
            <th class="centered-sorted-header col-narrow" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">Cameras</th>
            <td class="centered-sorted-header col-narrow" mat-cell *matCellDef="let element">
              <div class="count-badge">{{element.numberOfCameras || 0}}</div>
            </td>
          </ng-container>

        <!-- Username Column -->
        <ng-container matColumnDef="analyticID">
          <th class="centered-sorted-header col-id" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">AID</th>
          <td class="centered-sorted-header col-id" mat-cell *matCellDef="let element">{{ element.analyticId }}</td>
        </ng-container>
        <!-- Email ID Column -->
        <ng-container matColumnDef="potentialId">
          <th class="centered-sorted-header col-id" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">Potential ID</th>
          <td class="centered-sorted-header col-id" mat-cell *matCellDef="let element">{{ element.potentialId }}</td>
        </ng-container>

        <!-- Phone No Column -->
        <ng-container matColumnDef="accountId">
          <th class="centered-sorted-header col-id" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">Account ID</th>
          <td class="centered-sorted-header col-id" mat-cell *matCellDef="let element">{{ element.accountId }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th class="centered-sorted-header col-status" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">Status</th>
          <td class="centered-sorted-header col-status" mat-cell *matCellDef="let element">{{ element?.status }}</td>
        </ng-container>
        <ng-container matColumnDef="stage">
          <th class="centered-sorted-header col-status" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">Stage</th>
          <td class="centered-sorted-header col-status" mat-cell *matCellDef="let element">{{ element?.stage }}</td>
        </ng-container>
        <!-- Users Column -->
        <ng-container matColumnDef="Users">
          <th class="centered-sorted-header col-narrow" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">Users</th>  
          <td class="centered-sorted-header col-narrow" mat-cell *matCellDef="let element" (click)="element?.users?.length ? openAssignedUsers(element) : null">
            <div class="count-badge">{{ (element?.users?.length === 0) ? '0' : (element?.users?.length || 0) }}</div>
          </td>
        </ng-container>
        <!-- Summary Count Column -->
        <ng-container matColumnDef="summaryCount">
          <th class="centered-sorted-header col-narrow" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">Summary</th>
          <td class="centered-sorted-header col-narrow summary-count-btn"
              mat-cell
              *matCellDef="let element"
              (click)="element?.summaryCount ? navigateToSummaryDetails(element) : null">
            <div class="count-badge">{{ element?.summaryCount ?? 0 }}</div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedSitesColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedSitesColumns;"></tr>
      </table>
    </div>
    
    <!-- Pagination -->
    <mat-paginator [length]="totalSites" 
                   [pageSize]="sitePageSize"
                   [pageSizeOptions]="[8, 25, 50, 100]"
                   [pageIndex]="sitePageIndex"
                   showFirstLastButtons 
                   (page)="onSitePageChange($event)"></mat-paginator>
  </div>
            </mat-tab>
            <mat-tab label="CF Issues" *ngIf="canAccessCfIssues">
              <div class="header-container">
                <div class="title-container">
                  <h2 class="label">
                    <mat-icon name="list" class="list">bug_report</mat-icon>
                    <span class="title">CF Issues</span>
                  </h2>
                </div>
                <form [formGroup]="cfIssuesForm" class="form-inline um-toolbar">
                  <mat-form-field appearance="fill" floatLabel="always" class="form-field cf-autocomplete-field">
                    <mat-label>Search by Site Name or Potential ID</mat-label>
                    <input matInput formControlName="potentialId" placeholder="Type to search sites..." type="text" autocomplete="off"
                      [matAutocomplete]="cfSiteAuto"
                      (input)="onCfSiteSearchInput(cfIssuesForm.get('potentialId')?.value)">
                    <mat-autocomplete #cfSiteAuto="matAutocomplete" [displayWith]="displayCfSite.bind(this)"
                      (optionSelected)="onCfSiteSelected($event.option.value)">
                      <mat-option *ngFor="let site of cfSiteOptions" [value]="site">
                        {{ site.siteName }} ({{ site.potentialId }})
                      </mat-option>
                    </mat-autocomplete>
                    <button mat-icon-button matSuffix class="suffix-icon-btn" *ngIf="getCfPotentialId()" (click)="clearCfIssuesSearch()">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </form>
              </div>
              <p class="cf-issues-hint">Select a Potential ID above, then run each checker individually below.</p>
              <div class="table-container table-responsive cf-issues-results">
                <!-- RTSP Checker Section -->
                <div class="cf-result-section cf-checker-block">
                  <div class="cf-section-header">
                    <h4 class="cf-result-title">RTSP Checker</h4>
                    <button mat-raised-button color="primary" (click)="runRtspCheck()" [disabled]="!getCfPotentialId()" class="cf-run-btn">
                      <mat-icon *ngIf="!cfIssuesRtspLoading">play_arrow</mat-icon>
                      <mat-spinner *ngIf="cfIssuesRtspLoading" diameter="20"></mat-spinner>
                      {{ cfIssuesRtspLoading ? 'Checking...' : 'Run Check' }}
                    </button>
                  </div>
                  <div *ngIf="cfIssuesApi1Result !== null" class="cf-result-body">
                    <pre class="cf-result-data">{{ cfIssuesApi1Result | json }}</pre>
                  </div>
                  <div *ngIf="cfIssuesApi1Result === null && !cfIssuesRtspLoading" class="cf-no-result-inline">No result yet. Click Run Check.</div>
                </div>
                <!-- Packet Loss Checker Section -->
                <div class="cf-result-section cf-checker-block">
                  <div class="cf-section-header">
                    <h4 class="cf-result-title">Packet Loss Checker</h4>
                    <button mat-raised-button color="primary" (click)="runPacketLossCheck()" [disabled]="!getCfPotentialId()" class="cf-run-btn">
                      <mat-icon *ngIf="!cfIssuesPacketLossLoading">play_arrow</mat-icon>
                      <mat-spinner *ngIf="cfIssuesPacketLossLoading" diameter="20"></mat-spinner>
                      {{ cfIssuesPacketLossLoading ? 'Checking...' : 'Run Check' }}
                    </button>
                  </div>
                  <div *ngIf="cfIssuesApi2Result !== null" class="cf-result-body">
                    <pre class="cf-result-data">{{ cfIssuesApi2Result | json }}</pre>
                  </div>
                  <div *ngIf="cfIssuesApi2Result === null && !cfIssuesPacketLossLoading" class="cf-no-result-inline">No result yet. Click Run Check.</div>
                </div>
                <!-- Docker Services Checker Section -->
                <div class="cf-result-section cf-checker-block">
                  <div class="cf-section-header">
                    <h4 class="cf-result-title">Docker Services Checker</h4>
                    <button mat-raised-button color="primary" (click)="runDockerServiceCheck()" [disabled]="!getCfPotentialId()" class="cf-run-btn">
                      <mat-icon *ngIf="!cfIssuesDockerLoading">play_arrow</mat-icon>
                      <mat-spinner *ngIf="cfIssuesDockerLoading" diameter="20"></mat-spinner>
                      {{ cfIssuesDockerLoading ? 'Checking...' : 'Run Check' }}
                    </button>
                  </div>
                  <div *ngIf="cfIssuesApi3Result !== null" class="cf-result-body">
                    <pre class="cf-result-data">{{ cfIssuesApi3Result | json }}</pre>
                  </div>
                  <div *ngIf="cfIssuesApi3Result === null && !cfIssuesDockerLoading" class="cf-no-result-inline">No result yet. Click Run Check.</div>
                </div>
                <!-- CPU and RAM Checker Section -->
                <div class="cf-result-section cf-checker-block">
                  <div class="cf-section-header">
                    <h4 class="cf-result-title">CPU and RAM Checker</h4>
                    <button mat-raised-button color="primary" (click)="runSystemResourceCheck()" [disabled]="!getCfPotentialId()" class="cf-run-btn">
                      <mat-icon *ngIf="!cfIssuesSystemResourceLoading">play_arrow</mat-icon>
                      <mat-spinner *ngIf="cfIssuesSystemResourceLoading" diameter="20"></mat-spinner>
                      {{ cfIssuesSystemResourceLoading ? 'Checking...' : 'Run Check' }}
                    </button>
                  </div>
                  <div *ngIf="cfIssuesApi4Result !== null" class="cf-result-body">
                    <pre class="cf-result-data">{{ cfIssuesApi4Result | json }}</pre>
                  </div>
                  <div *ngIf="cfIssuesApi4Result === null && !cfIssuesSystemResourceLoading" class="cf-no-result-inline">No result yet. Click Run Check.</div>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Dashboard" *ngIf="isSuperAdmin">
              <div class="header-container">
                <div class="title-container">
                  <h2 class="label">
                    <mat-icon>dashboard</mat-icon>
                    <span class="title">Dashboard</span>
                  </h2>
                </div>
              </div>
              <div class="tab-content">
                <app-dashboard></app-dashboard>
              </div>
            </mat-tab>
            
            <!-- Site Report Dashboard Tab -->
            <mat-tab label="Site Reports" *ngIf="showReportDashboard">
              <div class="header-container">
                <div class="title-container">
                  <h2 class="label">
                    <mat-icon>analytics</mat-icon>
                    <span class="title">Site Report Dashboard</span>
                  </h2>
                  <button mat-icon-button (click)="closeReportDashboard()" class="close-btn">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
              <div class="tab-content">
                <app-site-report-dashboard 
                  [eventData]="currentReportData"
                  [siteName]="currentSiteName">
                </app-site-report-dashboard>
              </div>
            </mat-tab>

            <!-- Debug Tab (Temporary) - Commented out to fix compilation errors -->
            <!--
            <mat-tab label="Debug API" *ngIf="false">
              <div class="header-container">
                <div class="title-container">
                  <h2 class="label">
                    <mat-icon>bug_report</mat-icon>
                    <span class="title">API Debug Tools</span>
                  </h2>
                </div>
              </div>
              <div class="tab-content">
                <div class="debug-tools">
                  <h3>API Testing Tools</h3>
                  <div class="button-group">
                    <button mat-raised-button color="primary" (click)="testApiDirectly()">
                      <mat-icon>api</mat-icon>
                      Test API Directly
                    </button>
                    <button mat-raised-button color="accent" (click)="quickTest()">
                      <mat-icon>test</mat-icon>
                      Quick Test
                    </button>
                  </div>
                  <div class="debug-info">
                    <p><strong>Instructions:</strong></p>
                    <ol>
                      <li>Click "Test API Directly" to test the API endpoint</li>
                      <li>Check browser console for detailed logs</li>
                      <li>Look for response status and data</li>
                      <li>Check Network tab for request/response details</li>
                    </ol>
                  </div>
                </div>
              </div>
            </mat-tab>
            -->
          </mat-tab-group>
        </div>
      </div>
    </article>
  </div>
</section>
